import _Object$fromEntries from '@babel/runtime-corejs3/core-js-stable/object/from-entries';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$values from '@babel/runtime-corejs3/core-js-stable/object/values';
import colorToken from '../assets/color.json.js';

var _context, _context2;
var COLOR = _Object$fromEntries(_mapInstanceProperty(_context = _filterInstanceProperty(_context2 = _Object$values(colorToken)).call(_context2, function (_ref) {
  var type = _ref.type;
  return type === 'SOLID';
})).call(_context, function (_ref2) {
  var name = _ref2.name,
    color = _ref2.color;
  return [name, color];
}));

export { COLOR };
